export function persistStreamSortPreference(sortBy: string, orderBy: string) {
    const sort = {
        sortBy: sortBy,
        orderBy: orderBy
      }
  
    window.localStorage.setItem("streamSort", JSON.stringify(sort));
  }
  
  export function getStreamSortPreference() {
    const sort = window.localStorage.getItem("streamSort");
    return sort ? JSON.parse(sort) : {sortBy: 'name', orderBy: 'ASC' };
  }

  export function persistStreamViewerPreference(view: string) {
    window.localStorage.setItem("streamView", view);
  }

  export function getStreamViewerPreference() {
    return window.localStorage.getItem("streamView");
  }